import PropTypes from 'prop-types';
import React from 'react';

class Image extends React.Component {
  static propTypes = {
    src: PropTypes.string.isRequired,
  };

  state = {
    error: false,
  };

  render() {
    if (this.state.error) {
      return null;
    }
    return (
      <img // eslint-disable-line
        {...this.props}
        onError={() => {
          this.setState({ error: true });
        }}
      />
    );
  }
}

export default Image;
